import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Chapter, Reveal } from "@/components/motion";
import { WHY_POINTS } from "@/data/site";

export default function WhyPreview() {
  return (
    <section className="bg-white py-28 lg:py-36" data-testid="why-section">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-wrap items-end justify-between gap-8">
          <div>
            <Chapter index="06" label="Why Formcore" />
            <Reveal delay={0.1}>
              <h2 className="mt-8 max-w-2xl font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-navy sm:text-5xl">
                Why Construction Businesses <span className="text-gold">Choose Formcore</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <Link
              to="/why-formcore"
              data-testid="why-more-link"
              className="inline-flex items-center gap-2 font-heading text-sm font-bold uppercase tracking-[0.15em] text-navy transition-colors hover:text-gold"
            >
              All the reasons
              <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-px border border-navy/10 bg-navy/10 sm:grid-cols-2 lg:grid-cols-4">
          {WHY_POINTS.map((point, i) => (
            <Reveal key={point.title} delay={(i % 4) * 0.06} className="h-full">
              <div
                className="group flex h-full flex-col bg-white p-7 transition-colors duration-300 hover:bg-navy"
                data-testid={`why-card-${i}`}
              >
                <span className="font-heading text-sm font-bold text-gold">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="mt-4 font-heading text-base font-bold leading-snug text-navy transition-colors duration-300 group-hover:text-white">
                  {point.title}
                </h3>
                <p className="mt-3 text-[13px] leading-relaxed text-charcoal/65 transition-colors duration-300 group-hover:text-white/65">
                  {point.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
